import React from 'react'
import {INIFINITY, NEGATIVE_INFINITY} from './helpers.cio.drawerContent'

type FilterPriceRangeInputProps = {
    minOnChange: (e: React.FocusEvent<HTMLInputElement>) => void
    maxOnChange: (e: React.FocusEvent<HTMLInputElement>) => void
    priceRange?: {min?: string; max?: string}
}

export const FilterPriceRangeInput: React.FC<FilterPriceRangeInputProps> = ({
    minOnChange,
    maxOnChange,
    priceRange
}) => {
    const [min, setMin] = React.useState(priceRange?.min ?? NEGATIVE_INFINITY)
    const [max, setMax] = React.useState(priceRange?.max ?? INIFINITY)

    React.useEffect(() => {
        setMin(priceRange?.min ?? NEGATIVE_INFINITY)
        setMax(priceRange?.max ?? INIFINITY)
    }, [priceRange?.min, priceRange?.max])

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const allowedKeys = [
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'Enter',
            'Home',
            'End',
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown'
        ]

        if (
            allowedKeys.includes(e.key) ||
            // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
            (e.ctrlKey && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase()))
        ) {
            return
        }

        if (!/^[0-9]$/.test(e.key)) {
            e.preventDefault()
        }
    }

    const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length > 10) {
            return
        }
        const value = e.target.value
        setMin(value)
    }

    const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length > 10) {
            return
        }
        const value = e.target.value
        setMax(value)
    }

    const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
        e.currentTarget.blur()
        e.preventDefault()
    }

    return (
        <div className="flex flex-col space-y-4">
            <div className="flex items-center space-x-4">
                {/* Min Input */}
                <div className="flex flex-col">
                    <label className="text-[#2F4A74] text-sm mb-1" htmlFor="min-price-input">
                        Min
                    </label>
                    <div className="flex items-center border border-[#2F4A74] rounded-2xl px-3 py-2">
                        <span className="text-[#2F4A74] mr-2 text-lg">$</span>
                        <input
                            id="min-price-input"
                            type="number"
                            placeholder="0"
                            className="outline-none w-20 text-[#2F4A74]"
                            value={min}
                            onChange={handleMinChange}
                            onBlur={(e) => minOnChange(e)}
                            onKeyDown={handleKeyDown}
                            onWheel={handleWheel}
                        />
                    </div>
                </div>

                <span className="text-[#2F4A74]">to</span>

                {/* Max Input */}
                <div className="flex flex-col">
                    <label className="text-[#2F4A74] text-sm mb-1" htmlFor="max-price-input">
                        Max
                    </label>
                    <div className="flex items-center border border-[#2F4A74] rounded-2xl px-3 py-2">
                        <span className="text-[#2F4A74] mr-2 text-lg">$</span>
                        <input
                            id="max-price-input"
                            type="number"
                            placeholder="0"
                            className="outline-none w-20 text-[#2F4A74]"
                            value={max}
                            onChange={handleMaxChange}
                            onBlur={(e) => maxOnChange(e)}
                            onKeyDown={handleKeyDown}
                            onWheel={handleWheel}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
